import React from 'react';
import { FormGroup } from '@mui/material';
import { LevelComponentAttributes } from '@loyalty/editor-components';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SelectField } from '../../../../shared/forms/fields/SelectField';
import { SwitchField } from '../../../../shared/forms/fields/SwitchField';
import { Trait } from '../utils/Trait';
import { TraitFormValue } from '../types';

type FormValue = TraitFormValue<LevelComponentAttributes, void>;

export function LevelV2WidgetTraits() {
  const { t } = useTranslation();

  const { watch, control } = useFormContext<FormValue>();
  const showAmountUntilNextLevel = watch('attributes.showAmountUntilNextLevel');

  const formatOptions = [
    { id: 'direct', name: t('editor.level.traits.progressFormat.direct') },
    { id: 'fraction', name: t('editor.level.traits.progressFormat.faction') },
  ];

  return (
    <FormGroup>
      <Trait>
        <SwitchField<FormValue>
          name="attributes.showProgressBar"
          label={t('editor.level.traits.showProgressBar')}
        />
      </Trait>
      <Trait>
        <SwitchField<FormValue>
          name="attributes.showLevelName"
          label={t('editor.level.traits.showLevelName')}
        />
      </Trait>
      <Trait>
        <SwitchField<FormValue>
          name="attributes.showAmountUntilNextLevel"
          label={t('editor.level.traits.showAmountUntilNextLevel')}
        />
      </Trait>
      {showAmountUntilNextLevel && (
        <Trait>
          <SelectField
            control={control}
            name="attributes.progressFormat"
            label={t('editor.leaderboard.traits.profileNameFormat')}
            options={formatOptions}
          />
        </Trait>
      )}
      <Trait>
        <SwitchField<FormValue>
          name="attributes.showExpiration"
          label={t('editor.leaderboard.traits.showExpiration')}
        />
      </Trait>
    </FormGroup>
  );
}
